import { render, staticRenderFns } from "./URLShareLayer.vue?vue&type=template&id=0a252e16&"
import script from "./URLShareLayer.vue?vue&type=script&lang=js&"
export * from "./URLShareLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a252e16')) {
      api.createRecord('0a252e16', component.options)
    } else {
      api.reload('0a252e16', component.options)
    }
    module.hot.accept("./URLShareLayer.vue?vue&type=template&id=0a252e16&", function () {
      api.rerender('0a252e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/URLShare/URLShareLayer.vue"
export default component.exports